import { render } from "./VehicleType.vue?vue&type=template&id=c37c6a08&scoped=true"
import script from "./VehicleType.vue?vue&type=script&lang=js"
export * from "./VehicleType.vue?vue&type=script&lang=js"

import "./VehicleType.vue?vue&type=style&index=0&id=c37c6a08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c37c6a08"]])

export default __exports__